import axios from 'axios'
import { ProtocolIndexResponse } from '@/api/services/common/protocol/common-protocol.dto'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CommonProtocolService {
    async getProtocolsBySampleIds(laboratoryId: number, caseId: number, sampleIds: number[]): Promise<ProtocolIndexResponse[]> {
        const response = await axios.get<ProtocolIndexResponse[]>(
            `/laboratories/${laboratoryId}/cases/${caseId}/samples/protocols/index`,
            { params: { sampleIds } })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.prtName), ['asc'])
    }

    async getProtocols(laboratoryId: number): Promise<ProtocolIndexResponse[]> {
        const response = await axios.get<ProtocolIndexResponse[]>(`/laboratories/${laboratoryId}/protocols/index`)
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.prtName), ['asc'])
    }
}

export const commonProtocolService = new CommonProtocolService()
